import { useEffect, useState } from 'react'

import { useUser } from '@/lib/auth/useUser'
import tenantChrome from '@/lib/tenantChrome'
import { hasTenantAdminSession } from '@/lib/tenantAdminAuth'

/**
 * The navbar Login button: where it goes, and whether it reads "Dashboard".
 *
 * A tenant whose `loginHref` is the Sales dashboard counts a stored
 * tenant-admin token as signed in. The href stays the login page either
 * way: `/tenant-admin/login` forwards a signed-in account to its first
 * enabled page, so the button never has to know the portal config.
 */
export function useNavbarLogin(): { href: string; signedIn: boolean } {
	const { user } = useUser()
	const href = tenantChrome.loginHref
	const [adminSignedIn, setAdminSignedIn] = useState(false)

	useEffect(() => {
		// document.cookie is client-only; reading it after mount keeps the
		// server render and the first client render identical.
		setAdminSignedIn(href.startsWith('/tenant-admin') && hasTenantAdminSession())
	}, [href])

	return { href, signedIn: Boolean(user) || adminSignedIn }
}
